import { Injectable } from '@angular/core';
import { ITransactionFormData } from '../model/transaction-form-data.model';
import { v4 as uuidv4 } from 'uuid';
import { SignatureType, SigningRequestChannel } from 'ngx-mat-esign360';
import { ITransactionData } from '../model/transaction-data.model';
import { ProfileService } from '@app/core/services/profile.service';

@Injectable({
  providedIn: 'root',
})
export class EmptyTransactionDataFactoryService {
  constructor(private profileService: ProfileService) {}

  createEmptyTransactionFormData(): ITransactionFormData {
    const profile = this.profileService.getCurrentProfile();

    return {
      name: '',
      clients: [
        {
          cid: uuidv4(),
          forename: '',
          surname: '',
          birthYear: '',
          personalId: '',
          email: '',
          phone: '',
          signingRequest: {
            channel: SigningRequestChannel.None,
            subject: profile.defaultRequestSignatureSubject,
            body: profile.defaultRequestSignatureBody,
          },
        },
      ],
      invokingUser: {
        sendMailIfCompleted: profile.defaultSendMailIfCompleted,
        email: '',
      },
      documents: { clientsToDocs: [] },
    };
  }

  createEmptyTransactionData(): ITransactionData {
    return {
      formData: this.createEmptyTransactionFormData(),
      documentsData: [],
      signFieldsByDocument: {},
      defaultSignatureType: SignatureType.Hand,
      autoIncrementClientId: false,
    };
  }
}
